<template>
  <div class="f-wrapper">
    <slot></slot>
  </div>
</template>
<script>
export default {};
</script>

<style lang="scss">
.f-wrapper {
  &:hover {
    background: rgba(24, 144, 211, 0.1);
  }

  /* Wrapper */

  cursor: pointer;

  transition: 125ms ease background-color;

  /* Auto layout */

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px;

//   position: static;
//   width: 156px;
//   height: 40px;
//   left: 4px;
//   top: 4px;

  /* Blue/10% */

  border-radius: 6px;

  /* Inside auto layout */
}
</style>